import { render, staticRenderFns } from "./VideoCard.ts.vue?vue&type=template&id=7be51026"
import script from "./VideoCard.ts.vue?vue&type=script&setup=true&lang=ts"
export * from "./VideoCard.ts.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./VideoCard.ts.vue?vue&type=style&index=0&id=7be51026&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports